document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const featuresAnimationContainer = document.querySelector('.features-animation-container');
    const bidet = document.querySelector('.bidet');
    const bidetLines = document.querySelectorAll('.bidet-lines');
    const waterContainer = document.querySelector('.water-container');
    const battery = document.querySelector('.battery');
    const firstFeatureContent = document.querySelector('.feature-1-content');
    const secondFeatureContent = document.querySelector('.feature-2-content');
    const thirdFeatureContent = document.querySelector('.feature-3-content');
    const breakPoint = 768;

    let mm = gsap.matchMedia();

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: featuresAnimationContainer,
            start: 'top 300px',
            end: '+=1200',
            scrub: true,
        }
    });

    tl.to(bidetLines, {
        xPercent: -70,
        ease: 'power3.out', // Smooth easing
    }, "1")
        .to(bidet, {
            xPercent: -40,
            yPercent: 150,
            width: "20%",
            ease: 'power3.out', // Smooth easing
        }, '1')
        .to(waterContainer, {
            xPercent: -110,
            ease: 'power3.out', // Smooth easing
        }, "1")
        .fromTo(battery, {
            yPercent: 210,
        }, {
            yPercent: 46,
            ease: 'power3.out', // Smooth easing
        }, "1")
        .to(firstFeatureContent, {
            yPercent: -50,
            opacity: 0,
            ease: 'power3.inOut', // Smooth in and out easing
        }, "1")
        .fromTo(secondFeatureContent, {
            yPercent: 50,
        }, {
            yPercent: 0,
            opacity: 1,
            ease: 'power3.inOut', // Smooth in and out easing
        }, "1");

    mm.add(
        {
            isDesktop: `(min-width: ${breakPoint}px)`,
            isMobile: `(max-width: ${breakPoint - 1}px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)",
        },
        (context) => {
            let { isDesktop } = context.conditions;

            tl.to(battery, {
                yPercent: isDesktop ? 6 : -6,
                xPercent: -50,
                width: "40%",
                ease: 'power3.out', // Smooth easing
            }, "2")
                .to(bidet, {
                    xPercent: 0,
                    yPercent: isDesktop ? -100 : 100,
                    ease: 'power3.out', // Smooth easing
                }, "2")
                .to(waterContainer, {
                    xPercent: 0,
                    ease: 'power3.out', // Smooth easing
                }, "2")
                .to(secondFeatureContent, {
                    yPercent: -50,
                    opacity: 0,
                    ease: 'power3.inOut', // Smooth in and out easing
                }, "2")
                .fromTo(thirdFeatureContent, {
                    yPercent: 50,
                }, {
                    yPercent: 0,
                    opacity: 1,
                    ease: 'power3.inOut', // Smooth in and out easing
                }, "2");
        });
});
